import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { tableConfig } from '../../../../../settings/index';
import Api from '../../../../../helpers/api';
import { sendRequest } from '../../../../../helpers/saga';
import { logger } from '../../../../../helpers/logger';
import notifications from '../../../../../redux/notifications/actions';

function* loadData({ payload }) {
  try {
    const { page = 1, pageSize = tableConfig.pageSize, column, order, filter = '', id: parent_id } = payload;

    const api = new Api('units/parent_page_list');

    const result = yield call(
      sendRequest,
      api.load,
      { search: { page, pageSize, column, order, filter, parent_id } },
      notifications.REQUEST_ERROR,
    );

    if (result) {
      const { data, totalCount, filteredCount, sortable_columns } = result.data;

      yield put(
        actions.loadDataSuccess({
          data,
          total: totalCount,
          filteredTotal: filteredCount,
          sortableColumns: sortable_columns,
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD, loadData)]);
}
